/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import reactCSS from 'reactcss';
import { LoadableResponsiveImage as ResponsiveImage } from '../../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalQualificationSellingPoint.scss';

export const PortalQualificationSellingPoint = function (props) {
  const { sellingPoint, firstChild, lastChild } = props;
  const color = sellingPoint.get('color', '#61beb2') || '#61beb2';
  const borderWidth = 4;
  const size = 48;

  const styles = reactCSS(
    {
      default: {
        background: {
          content: '',
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          border: `3px solid ${color}`,
        },
        text: {
          color,
        },
        corner: {
          borderColor: color,
        },
      },
      withImage: {
        text: {
          color: 'white',
        },
        corner: {
          borderColor: 'white',
        },
      },
      withBevel: {
        corner: {
          content: '',
          display: 'block',
          backgroundColor: 'white',
          borderWidth: `${borderWidth}px`,
          borderColor: 'transparent',
          borderStyle: 'solid',
          width: `${size}px`,
          height: `${size}px`,
          position: 'absolute',
        },
      },
      topLeft: {
        corner: {
          borderRightColor: color,
          transform: 'skew(-45deg)',
          top: `-${borderWidth}px`,
          left: `-${size / 2}px`,
        },
      },
      bottomRight: {
        corner: {
          borderLeftColor: color,
          transform: 'skew(-45deg)',
          bottom: `-${borderWidth}px`,
          right: `-${size / 2}px`,
        },
      },
    },
    {
      withImage: !!sellingPoint.get('imageSrc'),
      withBevel: firstChild || lastChild,
      topLeft: firstChild,
      bottomRight: lastChild,
    }
  );

  return (
    <div className="selling-point-wrapper">
      <ResponsiveImage
        background
        backgroundClassName="selling-point-box"
        responsive
        resizeWidthOnly
        onResize="up"
        src={sellingPoint.get('imageSrc')}
      >
        {!sellingPoint.get('imageSrc') && <div style={styles.background} />}
        <div className="selling-point">
          {sellingPoint.get('text') ? (
            <h4 style={styles.text}>{sellingPoint.get('text')}</h4>
          ) : null}
          {firstChild || lastChild ? (
            <div className="selling-point-corner" style={styles.corner} />
          ) : null}
        </div>
      </ResponsiveImage>
    </div>
  );
};

PortalQualificationSellingPoint.displayName = 'PortalQualificationSellingPoint';
PortalQualificationSellingPoint.propTypes = {
  sellingPoint: ImmutablePropTypes.mapContains({
    imageSrc: PropTypes.string,
    text: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
  firstChild: PropTypes.bool,
  lastChild: PropTypes.bool,
};
